import RenderInput from "./RenderInput";
import RenderDatePicker from "./RenderDatePicker";
import RenderTimePicker from "./RenderTimePicker";
import RenderRating from "./RenderRating";
import RenderRadio from "./RenderRadio";
import RenderCheckbox from "./RenderCheckbox";
import RenderSelect from "./RenderSelect";
import RenderSubQuestion from "./RenderSubQuestion";

export default function QuestionOptionContent(props) {
	const {
		namePath = [],
		type = null,
		required = false,
		form_question_options = [],
	} = props;

	switch (type) {
		case "Text (Input)":
			return (
				<RenderInput
					namePath={namePath}
					required={required}
					form_question_options={form_question_options}
				/>
			);

		case "Number (Input)":
			return (
				<RenderInput
					namePath={namePath}
					required={required}
					form_question_options={form_question_options}
					inputType="number"
				/>
			);

		case "Date (Datepicker)":
			return <RenderDatePicker namePath={namePath} required={required} />;

		case "Time (Timepicker)":
			return <RenderTimePicker namePath={namePath} required={required} />;

		case "Rating":
			return (
				<RenderRating
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
				/>
			);

		case "Radio (Button)":
			return (
				<RenderRadio
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
				/>
			);

		case "Checkbox":
			return (
				<RenderCheckbox
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
				/>
			);

		case "Select (Dropdown)":
			return (
				<RenderSelect
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
				/>
			);

		case "sub_question":
			return (
				<RenderSubQuestion
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
				/>
			);

		default:
			return null;
	}
}
